import { XHRRequestCanceler } from '../../../../Libs/xhr/XHRRequestCanceler';
import {
    IMessageDataService,
    MessageDataServiceName,
} from '../../../DataServices/MessageDataService';
import { Lazy } from '../../../Helpers/Lazy';
import { BaseApiDataResponse } from '../../../Models/ApiData';
import { MessageApiDataResponse } from '../../../Models/Message/Message';
import { IoC } from '../../ServicesContainer';
import { BaseReduxService } from '../Api/BaseReduxService';

export interface IMessageService {
    getMessage: (cts: XHRRequestCanceler) => Promise<MessageApiDataResponse>;

    setMessage: (
        requestParams: {
            content: string;
            is_active: boolean;
        },
        cts: XHRRequestCanceler
    ) => Promise<BaseApiDataResponse>;
}

class MessageService extends BaseReduxService implements IMessageService {
    private readonly pointageDataService: Lazy<IMessageDataService>;

    constructor() {
        super();
        this.pointageDataService = IoC.getLazy<IMessageDataService>(MessageDataServiceName);
    }

    public getMessage = async (cts: XHRRequestCanceler) => {
        try {
            const response = await this.pointageDataService.value().getMessage(cts);
            return Promise.resolve(response);
        } catch (err) {
            return Promise.reject(err);
        }
    };

    public setMessage = async (
        requestParams: {
            content: string;
            is_active: boolean;
        },
        cts: XHRRequestCanceler
    ) => {
        try {
            const response = await this.pointageDataService.value().setMessage(requestParams, cts);
            return Promise.resolve(response);
        } catch (err) {
            return Promise.reject(err);
        }
    };
}

const MessageServiceName = 'MessageService';
export { MessageService, MessageServiceName };
